import { ReactNode } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setSidebarCollapsed } from '../../store/actions/layout';
import Header from './Header';
import Sidebar from './Sidebar';
import './style.css';

interface LayoutProps {
  children: ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  const dispatch = useDispatch();
  const isCollapsed = useSelector((state: any) => {
    return state.layout.isSidebarCollapsed;
  });
  const isProduction = process.env.NODE_ENV === 'production';

  const handleCollapse = (collapsed: boolean) => {
    console.log('Layout handleCollapse called with:', collapsed);
    dispatch(setSidebarCollapsed(collapsed));
  };

  return (
    <div className={`d-flex ${isCollapsed ? 'sidebar-collapsed' : ''} ${isProduction ? 'production-build' : ''}`} id="top-page">
      <Sidebar onCollapse={handleCollapse} />
      <div id="page-content-wrapper" className={isCollapsed ? 'sidebar-collapsed' : ''}>
        <Header />
        <div 
          className="container-fluid" 
          style={{ 
            flex: 1, 
            overflow: 'auto',
            minHeight: 'calc(100vh - 64px)', // Use minHeight instead of fixed height
            height: 'auto' // Allow natural height expansion
          }}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default Layout;
